import useFooter from "../../../logic/Footer";

const Footer = () => {
  const { footer, script } = useFooter();

  return (
    <footer className="hnf-footer" role="contentinfo">
      {footer && <div dangerouslySetInnerHTML={{ __html: footer }} />}
      {footer && script && <div dangerouslySetInnerHTML={{ __html: script }} />}
    </footer>
  );
};

export default Footer;
